import './App.css';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import { Auth } from "./pages/auth";
import { TodoList } from "./pages/todoList";
import  Dashboard  from "./pages/dashboard";
import PreSite from "./pages/preSite";
import  Movies  from "./pages/movies";
import Questions from "./pages/questions";
import Profil from "./components/logInUserInformation/profil";
import Calendar from "./pages/calendar";
import CreativeSpace from "./pages/creativeSpace";
import Cooking from "./pages/cooking";
import Home from "./pages/home";
import MovieContentCard from "./components/movies/movieContentCard";
import ShowContentCard from "./components/movies/showContentCard";
import Register from "./pages/register";
import VerifyEmail from "./pages/verifyEmail";
import VerifiedRoute from "./components/verifiedRoute";
import StreamingService from "./components/movies/streamingService";
import Favorites from "./components/movies/favorites";
import PrivateRoute from "./components/privateRoute";
import Notes from "./pages/notes";
import Study from "./pages/study";
import Questionnaire from "./components/logInUserInformation/Questionnaire";
import Minigames from './pages/minigames';
import { LanguageProvider } from "../src/i18n/LanguageProvider";


function App() {
    return (
        <div className="App">
            <LanguageProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<PreSite />} />
                    <Route path="/auth" element={<Auth />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/questionnaire" element={<VerifiedRoute><Questionnaire /></VerifiedRoute>} />

                    {/* Dashboard with nested routes */}
                    <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>}>                        {/* Dashboard index route */}
                        <Route index element={<Home />} />
                        <Route path="home" element={<Home />} />
                        <Route path="/dashboard/profil" element={<Profil />} />
                        {/* Dates section */}
                        <Route path="dates">
                            <Route path="movies" element={<Movies />} />
                            <Route path="movies/favorites" element={<Favorites />} />
                            <Route path="movies/:platformName" element={<StreamingService />} />
                            <Route path="cooking" element={<Cooking />} />
                            <Route path="questions" element={<Questions />} />
                            <Route path="minigames" element={<Minigames />} />

                        </Route>
                        {/* Organization section */}
                        <Route path="organization">
                            <Route path="notes" element={<Notes />} />
                            <Route path="calendar" element={<Calendar />} />
                            <Route path="todo-list" element={<TodoList />} />
                            <Route path="study" element={<Study />} />
                        </Route>

                        {/* Tracker section */}
                        <Route path="tracker">
                            <Route path="menstrual-tracker" element={<CreativeSpace />} />
                        </Route>

                        {/* Content routes */}
                        <Route path="content">
                            <Route path="movie/:id" element={<MovieContentCard />} />
                            <Route path="tv/:id" element={<ShowContentCard />} />
                        </Route>
                    </Route>

                    {/* Catch-all route */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
            </LanguageProvider>
        </div>
    );
}

export default App;
